interface StatCardProps {
  label: string;
  value: string | number;
  detail?: string;
}

export function StatCard({ label, value, detail }: StatCardProps) {
  return (
    <div className="rounded-3xl border border-gold/15 bg-black/20 p-5">
      <p className="text-xs uppercase tracking-[0.24em] text-mist">{label}</p>
      <p className="mt-3 text-3xl font-semibold text-parchment">{value}</p>
      {detail && <p className="mt-2 text-sm text-mist">{detail}</p>}
    </div>
  );
}
